(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('pageDataManager', PageDataManagerDirective);

  function PageDataManagerDirective() {
    return {
      restrict: 'E',
      templateUrl: 'views/data_manager/template.html',
      transclude: true
    };
  }
}());
